<template>
  <div align="center">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          class="button-circular color-icon"
          style="background-color: #eaeaf0 !important;"
          v-on="tooltip ? on : null"
          :loading="loading"
          :disabled="!!disabled"
          fab
          dark
          medium
          depressed
          @click="$emit('click')"
        >
          <img v-if="src" :src="src">
          <v-icon v-else dark>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <p v-if="label" class="pt-2 bold">{{ label }}</p>
  </div>
</template>

<script>
export default {
  props: ['label', 'icon', 'tooltip', 'src', 'loading', 'disabled'],
};
</script>

<style lang="scss">
.button-circular {
  height: 56px !important;
  width: 56px !important;
  margin-left: 8px;
  margin-right: 8px;
}
img {
  height: 20px;
  width: 20px;
}

.v-icon{
  height: 20px !important;
  width: 20px !important;
  font-size: 20px !important;
}
@media (max-width: 1024px) {
  .button-circular {
    margin-left: 3px !important;
    margin-right: 3px !important;
  }
}

@media (max-width: 1440px) {
  .button-circular {
    height: 46px !important;
    width: 46px !important;
  }
}
</style>
